import React from "react";
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Row,
	Col,
	NavItem,
	NavLink,
	Nav,
	Table
} from "reactstrap";

// Requests
import { getProjectRequest } from "api/project";
// Helpers
import { hasPermission } from "helpers/auth";
import { formatPrice } from "helpers/pricing"
class ProjectDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			project: null,
			activeTab: "information"
		}
	}

    goTo = path => this.props.history.push(path);

	async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
    	const id = params.get("id");

		await this.getProject(id)
	}

	getProject = async (id) => {
		const project = await getProjectRequest(id)

		this.setState({
			project
		})
	}

	changeActiveTab = (e, tabState, tadName) => {
		e.preventDefault();	
		this.setState({
		  [tabState]: tadName,
		});
	};

	renderActiveTab = (tab) => {
		const {
			project
		} = this.state;

		switch(tab) {
			case "information":
				return (
					<Row>
						<Col sm="8">
							<div className="typography-line">
								<h4>
									<span>ID</span>
									{project?._id}
								</h4>
							</div>
							<div className="typography-line">
								<h4>
									<span>Name</span>
									{project?.name}
								</h4>
							</div>
							<div className="typography-line">
								<h4>
									<span>Description</span>
									{project?.description || 'N/A'}
								</h4>
							</div>
							<div className="typography-line">
								<h4>
									<span>Max Commission</span>
									{project?.maxCommission || 7.5}%
								</h4>
							</div>
						</Col>
					</Row>
				)
			case "models":
				return (
					<Table responsive>
						<thead className="text-primary">
							<tr>
								<th>Name</th>
								<th>Price</th>
								<th>VAT</th>
								<th>TCP</th>
							</tr>
						</thead>
						<tbody>
							{project.models && project.models.length > 0 ?
								<>
									{project.models.map(model => (
									<tr>
										<td>{model.name || "N/A"}</td>
										<td>{formatPrice(model.price) || "N/A"}</td>
										<td>{formatPrice(model.vat) || "N/A"}</td>
										<td>{formatPrice(model.tcp) || "N/A"}</td>
									</tr>
									))}
								</>
							: 	<tr>
									<td colSpan="4">This project doesn't have any models yet</td>
								</tr>		
							}
						</tbody>
					</Table>
				)
			default: return <p>Default case in renderActiveTab</p>
		}
	}

    render() {
		const {
			activeTab,
			project
		} = this.state;

		const tabs = [
			{
				title: "Information",
				type: "information"
			},
			{
				title: "Models",
				type: "models"
			},
		];

        return (
            <div className="content">
				<Row>
					<Col md="12">
						<Card>
							<CardHeader className="mb-5">
								<CardTitle tag="h3">
									Project Details
								<Button
									className="float-right"
									color="default"
									onClick={() => this.goTo('/projects')}
								>
									Back
              					</Button>
								{hasPermission("EditProject") ? 
                                    	<Button
                                            className="float-right mr-2"
                                            color="default"
                                            onClick={() => this.goTo(`/project/edit?id=${project._id}`)}
                                        >
                                            Edit
                                        </Button>
                                    : 	null
                                }
              					</CardTitle>
								<Nav className="nav-pills-info" pills>
									{tabs.map((tab) => {
										return (
											<NavItem key={tab.title}>
												<NavLink
												data-toggle="tab"
												href="#pablo"
												className={
													this.state.activeTab === tab.type
													? "active"
													: ""
												}
												onClick={(e) =>
													this.changeActiveTab(
													e,
													"activeTab",
													tab.type
													)
												}
												>
												{tab.title}
												</NavLink>
											</NavItem>
										)
									})}
								</Nav>
							</CardHeader>
							<CardBody>
								{project ? this.renderActiveTab(activeTab) : "Carregando..."}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default ProjectDetails